import { useCallback, useMemo } from "react";
import Form from "rc-field-form";
import { useTranslation } from "react-i18next"
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";
import { Input } from "reactstrap";
import Modal from "../../../../components/Modal"
import Field from "../../../../components/Field";
import Button from "../../../../components/Button";
import Approve from "./Approve";
import { useRetroApi } from "../api";

function ApproveDenyModal({ visible, close, selected, selectedStatus, setData, setTotalItems }) {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const { updateRetroStatus } = useRetroApi();

    const onSuccess = useCallback((response) => {
        const message = selected?.type === "approve"
            ? t("retro-adjustment-approved")
            : selected?.type === "reopen" ? t("retro-adjustement-reopened") : t("retro-adjustement-rejected");
        toast.success(message);
        setData((prev) => {
            const data = [
                ...(prev || [])?.filter((item) => item.id !== response?.id),
                response
            ];
            return data?.filter((item) => item.status === selectedStatus);
        });
        if (
            (selectedStatus !== "rejected" && selected?.type === "reject") ||
            (selectedStatus !== "approved" && selected?.type === "approve") ||
            (selectedStatus === "approved" && selected?.type === "reopen")
        ) {
            setTotalItems((prev) => prev - 1);
        }
        close();
        form.resetFields();
    }, [selected?.type, t, setData, selectedStatus, close, form, setTotalItems]);

    const onFinish = useCallback((data) => {
        updateRetroStatus(selected?.id, selected?.type, data, onSuccess);
    }, [updateRetroStatus, onSuccess, selected?.id, selected?.type]);

    const onClose = useCallback(() => {
        form.resetFields();
        close();
    }, [close, form]);

    const content = useMemo(() => {
        if (selected?.type === "approve") {
            return <Approve values={selected} />
        } else {
            return (
                <Field name="reason">
                    <Input
                        type="textarea"
                        resize="none"
                        placeholder={t("reason")}
                        rows={6}
                    />
                </Field>
            );
        }
    }, [selected, t]);

    return (
        <Modal isOpen={visible} centered>
            <div className="w-100 py-4">
                <div className="mb-3 d-flex align-items-center justify-content-center flex-column text-primary font-weight-bold">
                    <FontAwesomeIcon
                        style={{ fontSize: 35 }}
                        icon={faCircleQuestion}
                        className="mb-3"
                    />
                    <h2>
                        {selected?.type === "approve"
                            ? t("do-you-want-to-approve-retro-adjustment")
                            : selected?.type === "reject"
                                ? t("do-you-want-to-reject-retro-adjustment")
                                : t("do-you-want-to-reopen-retro-adjustment")
                        }?
                    </h2>
                </div>

                <Form
                    className="w-100"
                    form={form}
                    onFinish={onFinish}
                >
                    {content}

                    <div className="d-flex justify-content-end">
                        <Button
                            color="muted"
                            onClick={onClose}
                        // disabled={loading}
                        >
                            {t("cancel")}
                        </Button>

                        <Button
                            type="submit"
                            color="primary"
                        // disabled={loading}
                        >
                            {selected?.type === "approve"
                                ? t("approve")
                                : selected?.type === "reopen"
                                    ? t("reopen")
                                    : t("reject")}
                        </Button>
                    </div>
                </Form>
            </div>
        </Modal>
    );
}

export default ApproveDenyModal;
